const env = import.meta.env;

const isTrue = (value?: string): boolean => value === 'true';

export const getAuth0DevelopmentSetup = (): string | undefined =>
  env.VITE_AUTH0_DEVELOPMENT_SETUP;

export const getAuth0DevelopmentDomain = (): string | undefined =>
  env.VITE_AUTH0_DEVELOPMENT_DOMAIN;

export const getAuth0DevelopmentClientId = (): string | undefined =>
  env.VITE_AUTH0_DEVELOPMENT_CLIENT_ID;

export const getApiUrlFromEnv = (): string | undefined => env.VITE_API_URL;

export const shouldEnableServiceWorkerInDev = (): boolean =>
  isTrue(env.VITE_ENABLE_SERVICE_WORKER_IN_DEV);

export const isProductFruitsDisabled = (): boolean =>
  isTrue(env.VITE_DISABLE_PRODUCTFRUITS);

export const isSentryDisabled = (): boolean =>
  isTrue(env.VITE_DISABLE_SENTRY);
export const isSentryEnabled = (): boolean => !isSentryDisabled();
export const isSentryDebuggingEnabled = (): boolean =>
  isTrue(env.VITE_ENABLE_SENTRY_DEBUGGING);

/**
 * Zustand stores report to Redux DevTools only on opt-in: the extension
 * serializes the whole state on every change (the inspection store holds the
 * full protocol), which costs GBs of memory and main-thread time.
 */
export const isStoreDevtoolsEnabled = (): boolean =>
  isTrue(env.VITE_STORE_DEVTOOLS);
